import type { IRecItemV2 } from '../repositories/feed-page/entities/recommendations/RecItemV2';
import type { TAnalyticsData, TClosestGeo, TRecommendation } from '../types/recommendation';

type TRawRecommendation = IRecItemV2 & {
  closestGeo?: TClosestGeo;
};

export function prepareRecommendations(rawRecommendations?: TRawRecommendation[], offset = 0): TRecommendation[] {
  if (!rawRecommendations) {
    return [];
  }

  return rawRecommendations.map(
    (
      {
        offerId,
        url,
        imageUrl,
        info,
        subtitle,
        title,
        underground,
        closestGeo,
        regionId,
        analyticsData = {},
        isFavorite,
        dealType,
        entityType,
        discount,
        contextToken,
        isCpcAuction,
      },
      index,
    ) => ({
      description: subtitle || '',
      href: url || '',
      imageUrl: imageUrl || '',
      title: title || '',
      transport: info,
      analyticsData: {
        offerId,
        type: offerId ? 'offer' : 'trap',
        ...analyticsData,
        products: offerId
          ? [
              {
                id: offerId,
                position: offset + index + 1,
                offerType: 'offer',
              },
            ]
          : undefined,
      } as TAnalyticsData,
      offerId: offerId || null,
      underground,
      ...(closestGeo ? { closestGeo } : null),
      ...(typeof regionId === 'number' ? { regionId } : null),
      isFavorite: isFavorite || false,
      dealType,
      entityType,
      discount,
      contextToken,
      isCpcAuction,
    }),
  );
}
